{
  "dynamics": {
    "title": "Динаміка залучення співробітників компанії"
  },
  "mental-balance-model": {
    "title": "Модель ментального балансу",
    "popover-content": "Це модель, що відображає основні компоненти життя людини. За основу взято ключову концепцію позитивної психотерапії. Наша модель включає в себе 4 основні сфери: тіло, діяльність, оточення та свідомість. \n\n ### Кожна сфера містить 2 взаємопов'язані складові: \n\nФізичний стан <=> Cамоконтроль \nВпевненість <=> Продуктивність \nСтосунки <=> Врівноваженість \nЖага до життя <=> Стресостійкість \n\nЛюдина досягає психологічного добробуту та високої якості життя в цілому при урівноваженні всіх сфер. Але навіть збалансування обох складових певної сфери додає ресурсу.",
    "link": {
      "text": "Відкрити динаміку",
      "desc": "Перехід на динаміку"
    }
  }
}
